export enum MapMessages {
  updateVehicleCurrentPosition = "map.updateVehicleCurrentLocation",
  errorFetchingAddressData = "map.errorFetchingAddressData",
  locationSearchTitle = "map.locationSearchTitle",
  typeLocationLabel = "map.typeLocationLabel",
  allVehiclesSearchLabel = "map.allVehiclesSearch",
  addressSearchLabel = "map.addressSearch",
  route = "map.route",
  outwardTrip = "map.outwardTrip",
  returnTrip = "map.returnTrip",
  names = "map.names",
  licensePlates = "map.license_plates",
  alerts = "map.alerts",
  states = "map.states",
  events = "map.events",
  viewLocation = "map.viewLocation",
  zmrc = "map.zmrc",
  invalidPolygon = "map.invalidPolygon",
  point = "map.point",
  stopped = "map.stopped",
  distanceToConstruction = "map.distanceToConstruction",
  showOnMap = "map.showOnMap",
  areas = "map.areas",
  construction = "map.construction",
  constructionNotLocked = "map.constructionNotLocked",
  invoiceAddress = "map.invoiceAddress",
  plant = "map.plant",
  trustedLocation = "map.trustedLocation",
  discharges = "map.discharges",
  dischargeInConstruction = "map.dischargeInConstruction",
  dischargeOutsideConstruction = "map.dischargeOutsideConstruction",
  alertTag = "map.alertTag",
  eventTag = "map.eventTag",
  stateTag = "map.stateTag",
  legendHint = "map.legendHint",
  legendOrderHint = "map.legendOrderHint",
  timeline = "map.timeline",
  replayPlay = "map.replayPlay",
  replayPause = "map.replayPause",
  travelMoment = "map.travelMoment",
  playbackSpeed = "map.playbackSpeed",
  replayFromHere = "map.replayFromHere",
  replayHint = "map.replayHint",
  fullscreen = "map.fullscreen",
  exitFullscreen = "map.exitFullscreen",
  fullscreenHint = "map.fullscreenHint",
  automaticTravel = "map.automaticTravel",
  automaticConstruction = "map.automaticConstruction",
  travelTime = "map.travelTime",
  fromConstruction = "map.fromConstruction",
  constructionHelp = "map.constructionHelp",
  constructionNotLockedHelp = "map.constructionNotLockedHelp",
  invoiceAddressHelp = "map.invoiceAddressHelp",
  plantHelp = "map.plantHelp",
  trustedLocationHelp = "map.trustedLocationHelp",
  dischargeInConstructionHelp = "map.dischargeInConstructionHelp",
  dischargeOutsideConstructionHelp = "map.dischargeOutsideConstructionHelp",
  addressSearchLoading = "map.addressSearchLoading",
  addressSearchUnavailable = "map.addressSearchUnavailable",
}

export type TranslationMapMessages = {
  [key in MapMessages]: string;
}
